import * as React from 'react';
import styled from 'styled-components';
import Values from 'values.js';

import { ClydeButton } from './ClydeButton';

import { IButtonColors } from 'src/types/IButton';
import { useTheme } from 'src/providers/ThemeProvider';

const StyledInvertedButton = styled(ClydeButton)<{ colors: IButtonColors }>`
  ${({ colors }) => (`
    background: ${colors.background};
    color: ${colors.text};
    border: 1px solid ${colors.border};

    &:focus, &:hover {
      background: ${colors.backgroundHover};
      // border-color: ?
    }

    &:active {
      background: ${colors.backgroundPressed};
    }
  `)}
`;

type InvertedButtonProps = React.ComponentPropsWithoutRef<'button'>;

export const InvertedButton = React.forwardRef<HTMLButtonElement, InvertedButtonProps>((props, ref) => {
  const { merchantColor } = useTheme();

  const color = React.useMemo(() => new Values(merchantColor), [merchantColor]);
  const colors = {
    background: color.tint(100).hexString(), // Completely lighten (to white)
    backgroundHover: color.tint(95).hexString(),
    backgroundPressed: color.tint(90).hexString(),
    border: color.hexString(),
    // NOTE: this logic doesn't work for light brand colors (closer to white than to black)
    text: color.hexString(),
  };

  return <StyledInvertedButton colors={colors} ref={ref} {...props} />;
});

InvertedButton.displayName = 'InvertedButton';
